/* * @Author: mikey.zhaopeng * @Date: 2025-05-26 15:38:47 * @Last Modified by:
mikey.zhaopeng * @Last Modified time: 2025-05-26 15:42:12 */ // 预览框
<template>
  <div class="popup">
    <el-dialog
    destroy-on-close
      :visible.sync="dialogVisible"
      @close="onClose"
      width="670px"
    >
      <div class="content">
        <div class="title">{{ title }}</div>
        <div class="box">
          <pdf
            :src="pdfSrc"
            :page="p"
            style="width: 100%"
            class="pdf"
            v-for="p in numPages"
            :key="p"
          />
        </div>
        <img
          src="@/assets/image/close2.webp"
          class="close"
          alt=""
          srcset=""
          @click="onHide"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  components: { pdf },
  props: {},
  data() {
    return {
      dialogVisible: false,
      title: "主播解除协议",
      pdfSrc: "",
      numPages: 0,
    };
  },
  created() {},
  computed: {},
  methods: {
    getPdfPage(pdfSrc) {
      pdf
        .createLoadingTask({
          url: pdfSrc,
        })
        .promise.then((pdfDoc) => {
          this.numPages = pdfDoc.numPages;
          this.dialogVisible = true;
        });
    },
    onClose() {
      this.onHide();
    },
    onShow({ src, title }) {
      this.pdfSrc = src;
      this.title = title;
      this.getPdfPage(src);
    },
    onHide() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  @include popupNo;
}
.content {
  position: relative;
  border-radius: 4px;
  //  overflow: hidden;
  .title {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 20px;
    font-weight: 500;
    color: #3d3d3d;
  }
  .box {
    border-radius: 4px;
    overflow-y: auto;
    height: 740px;
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -48px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
</style>
